export const signOutButton = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="signOutButton"
  >
    <title>Sign Out Button</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.925781 4.98C0.925781 2.50576 2.94426 0.5 5.43418 0.5H18.7983C19.3319 0.5 19.7644 0.929807 19.7644 1.46C19.7644 1.99019 19.3319 2.42 18.7983 2.42H5.43418C4.01137 2.42 2.85795 3.56615 2.85795 4.98V20.02C2.85795 21.4338 4.01137 22.58 5.43418 22.58H18.7983C19.3319 22.58 19.7644 23.0098 19.7644 23.54C19.7644 24.0702 19.3319 24.5 18.7983 24.5H5.43418C2.94426 24.5 0.925781 22.4942 0.925781 20.02V4.98Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.748 12.1788C10.748 11.6486 11.1806 11.2188 11.7141 11.2188H22.8241V13.1388H11.7141C11.1806 13.1388 10.748 12.7089 10.748 12.1788Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3227 17.3681C17.9455 16.9931 17.9455 16.3853 18.3227 16.0104L22.1938 12.1637L18.3227 8.31708C17.9455 7.94218 17.9455 7.33434 18.3227 6.95944C18.7 6.58454 19.3117 6.58454 19.689 6.95944L24.0154 11.2586C24.5185 11.7585 24.5185 12.569 24.0154 13.0688L19.689 17.3681C19.3117 17.743 18.7 17.743 18.3227 17.3681Z"
      fill="white"
    />
  </svg>
);
